import { ReactNode, useRef, useState } from "react";

export default function GestureDetector({
  children,
  onDrag,
  onSwipeLeft,
  onSwipeRight,
  onSwipeUp,
  onSwipeDown,
  onRelease,
}: {
  children: ReactNode;
  onDrag?: (deltaX: number, deltaY: number) => void;
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  onSwipeUp?: () => void;
  onSwipeDown?: () => void;
  onRelease?: (diffX: number, diffY: number) => void;
}) {
  const [startX, setStartX] = useState(0);
  const [endX, setEndX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [endY, setEndY] = useState(0);
  const containerRef = useRef<HTMLDivElement | null>(null);

  function handleTouchStart(e: React.TouchEvent<HTMLDivElement>) {
    const touch = e.targetTouches[0];
    if (touch === undefined) return;
    setStartX(touch.clientX);
    setStartY(touch.clientY);
    setEndX(touch.clientX);
    setEndY(touch.clientY);
  }

  function handleTouchMove(e: React.TouchEvent<HTMLDivElement>) {
    const touch = e.targetTouches[0];
    if (touch === undefined) return;
    setEndX(touch.clientX);
    setEndY(touch.clientY);
    if (onDrag !== undefined) {
      onDrag(touch.clientX - startX, touch.clientY - startY);
    }
  }

  function handleTouchEnd() {
    const diffX = endX - startX;
    const diffY = endY - startY;
    const clientWidth = containerRef.current?.clientWidth ?? 0;
    const clientHeight = containerRef.current?.clientHeight ?? 0;

    if (Math.abs(diffX) > Math.abs(diffY)) {
      if (onSwipeLeft && diffX < -clientWidth / 2) onSwipeLeft();
      if (onSwipeRight && diffX > clientWidth / 2) onSwipeRight();
    } else {
      if (onSwipeUp && diffY < -clientHeight / 2) onSwipeUp();
      if (onSwipeDown && diffY > clientHeight / 2) onSwipeDown();
    }

    if (onDrag) onDrag(0, 0);
    if (onRelease) onRelease(diffX, diffY);
  }

  return (
    <div
      ref={containerRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {children}
    </div>
  );
}
